import {
  getGiftCard as publicGetGiftCard,
  redeemGiftCard as publicRedeemGiftCard,
  voidTransaction as publicVoidTransaction,
} from './ecom-v1-gift-card-gift-vouchers.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getGiftCard: MaybeContext<
  BuildRESTFunction<typeof publicGetGiftCard> & typeof publicGetGiftCard
> = /*#__PURE__*/ createRESTModule(publicGetGiftCard);
export const redeemGiftCard: MaybeContext<
  BuildRESTFunction<typeof publicRedeemGiftCard> & typeof publicRedeemGiftCard
> = /*#__PURE__*/ createRESTModule(publicRedeemGiftCard);
export const voidTransaction: MaybeContext<
  BuildRESTFunction<typeof publicVoidTransaction> & typeof publicVoidTransaction
> = /*#__PURE__*/ createRESTModule(publicVoidTransaction);

export { Status } from './ecom-v1-gift-card-gift-vouchers.universal.js';
export {
  GiftCard,
  Money,
  GetGiftCardRequest,
  Context,
  GetGiftCardResponse,
  RedeemGiftCardRequest,
  RedeemGiftCardResponse,
  VoidTransactionRequest,
  VoidTransactionResponse,
  GetGiftCardResponseNonNullableFields,
  RedeemGiftCardResponseNonNullableFields,
  GetGiftCardOptions,
  RedeemGiftCardOptions,
  VoidTransactionOptions,
} from './ecom-v1-gift-card-gift-vouchers.universal.js';
